import { API_PATHS } from "./apiPaths";
import { axiosInstance } from "./axiosSetup";

export async function getPubpeerList(selectedJournalIds) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: {
      journal_ids: selectedJournalIds.join(',')
    },
    path: API_PATHS.METADATA_ANALYSIS,
    method: "get",
  });
}
